<a href="Javascript://">
    <h6 class="outer">
        <ng-content></ng-content>
        <div [ngClass]="isActive ? 'text-white bg-primary rounded-2' : ''" class="inner-text ps-2 pe-2"
            (click)="onClickSubdomain()">
            <span [title]="subdomain?.Label">{{subdomain?.Label}}</span>
        </div>
        <app-observation-comments-indicator class="ms-2 inner"
            [domainFilterId]="subdomain?.Value"></app-observation-comments-indicator>
        <app-observation-focus-area-indicator *ngIf="showFocusAreas" class="ms-2 inner" [isFocusArea]="isFocusArea" [readonly]="readonly"
            (onClickFocus)="onClickFocusArea($event)"></app-observation-focus-area-indicator>
    </h6>
</a>